import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PreAuthLayout } from '@/components/layout';

/**
 * Public Layout Route
 *
 * Wraps all unauthenticated screens (Landing, Login, SignUp, Invite) with
 * the brand gradient background, centred logo, and card shell provided by
 * PreAuthLayout.
 *
 * No auth guard — these routes are intentionally public.
 * Auth redirects (e.g. sending authenticated users to /dashboard) are
 * handled individually in each child route's beforeLoad.
 */
export const Route = createFileRoute('/_public')({
  component: () => (
    <PreAuthLayout>
      <Outlet />
    </PreAuthLayout>
  ),
});
